import { WarpUser, WarpUserCriteria } from "api/models/warpMaintenance";
import api from "api/utils";

const baseUrl = "api/warpmaintenance";

const getUsers = async (criteria?: WarpUserCriteria) => {
    return await api.query<WarpUserCriteria, WarpUser[]>({
        baseUrl: `${baseUrl}/users`,
        queryParams: criteria,
    });
};

const getWarps = async () => {
    return await api.query<undefined, string[]>({
        baseUrl: `${baseUrl}/warps`,
    });
};

const saveWarp = async (userId: string, warp: string) => {
    return await api.command<{ userId: string; warp: string }, undefined>({
        baseUrl: `${baseUrl}/warp`,
        method: "POST",
        body: { userId, warp },
    });
};

const warpMaintenanceService = {
    getUsers,
    getWarps,
    saveWarp,
};

export default warpMaintenanceService;
